import { memo } from "react";
import styles from "./BorderIndication.module.scss";
import cn from "classnames";

export interface IBorderIndication2Props {
  readonly className?: string;
  readonly itemClassName?: string;
  readonly size: number[];
  readonly rangeError?: boolean;
  readonly border?: boolean;
  readonly borderColor?: string;
}

function BorderIndication3(props: IBorderIndication2Props) {
  const currentSize = props.size.length ? props.size : [0];

  return (
    <div className={cn(styles.wrapper, props.className)}>
      {currentSize.map((s) => (
        <div
          className={cn(styles.item_wrapper, {
            [styles.border]: props.border,
          })}
          style={{ borderColor: props.borderColor }}
          key={Math.random() + s}
        >
          {Array.from(new Array(s + 1)).map((_, i) => (
            <div
              className={cn(styles.item, props.itemClassName, {
                [styles.range_error]: props.rangeError,
              })}
              key={Math.random() + s + i}
            />
          ))}
        </div>
      ))}
    </div>
  );
}

export default memo(BorderIndication3);
